import { useEffect, useMemo } from 'react'
import { initSocket } from 'helpers/socket'
import config from 'config'

const useSocket = (namespace = '/', enabled = true) => {
  const socket = useMemo(() => (enabled ? initSocket(namespace) : null), [namespace, enabled])

  useEffect(() => {
    if (!socket) {
      return
    }

    socket.connect()
    // makes it easy to test by allowing to emit events from the console
    if (config.isDev) window._socket = socket
    return () => {
      socket.disconnect()
      if (config.isDev) delete window._socket
    }
  }, [socket])

  return socket
}

export default useSocket
